import { Link } from '@tanstack/react-router'
import { UploadIcon } from 'lucide-react'

import { Button } from '@/components/ui'
import { useProject } from '@/modules/projects/hooks/project'
import { getProjectPath } from '@/utils'

// Goes to the Files tab, the same place Actions > Upload statements leads.
export const UploadStatementsButton = ({ label }: { label: string }) => {
  const slug = useProject()?.slug ?? ''
  return (
    <Button
      theme="outline"
      size="sm"
      className="h-7 font-medium text-blue-7"
      asChild
    >
      <Link to={`${getProjectPath({ slug })}/files`}>
        <UploadIcon />
        {label}
      </Link>
    </Button>
  )
}
